import { useRef, useState, useEffect } from 'react';
import { useThrottleFn } from 'ahooks';
import type { DropdownProps } from 'tea-component';

// 注意这个宽度 需要跟genreSelector目录下less文件中@overlay-width定义的宽度保持一致
const GENRE_SELECT_PANEL_WIDTH = 420;
// 组件下拉浮窗距离屏幕右侧的留白
const RIGHT_SPACING = 10;
// 下拉浮窗距离屏幕右侧的安全距离，（大于这个距离时，下拉浮窗placement为bottom-start，否则为bottom-end）
const SAFE_SPACING = GENRE_SELECT_PANEL_WIDTH + RIGHT_SPACING;

export default function useCascadPlacement() {
  const componentNode = useRef<HTMLDivElement>(null);

  const [placement, setPlacement] = useState<DropdownProps['placement']>('bottom-start');

  const calcPlacement = () => {
    const { clientWidth } = document.body;
    const componentRect = componentNode.current?.getBoundingClientRect();
    const componentLeft = componentRect?.left || 0;
    if (clientWidth - componentLeft < SAFE_SPACING) {
      setPlacement('bottom-end');
    } else {
      setPlacement('bottom-start');
    }
  };

  const { run: calcPlacementRun } = useThrottleFn(calcPlacement, {
    leading: true,
    trailing: true,
  });

  useEffect(() => {
    calcPlacementRun();

    window.addEventListener('resize', calcPlacementRun, false);

    return () => {
      window.removeEventListener('resize', calcPlacementRun);
    };
  }, []);

  return {
    componentNode,
    placement,
  };
}
